import { IPointBase } from "./IPoint";

export interface IMobilyticsScenario {
  address?: string;
  placeId: string;
  title: string;
  points: IPointBase[];
  polygonName: string;
  dateFrom: Date;
  dateTo: Date;
  hourFrom: number;
  hourTo: number;
  minuteFrom: number;
  minuteTo: number;
  milesLessOrGreater: string;
  miles: number;
  locationId: string;
  brandId: string;
}